<template>
  <div class="dsf-question-item-box">
    <template v-if="subjects.items.value == 'group'">
      <div @click="showImage" v-html="regHtml" class="group-title"></div>
      <div v-for="(groupChild, key) in subjects.children" child-refs="key" :key="groupChild.examQuestionsId">
        <dsf-exam-item
          :items-type="'group'"
          :show-score="showScore"
          :hide-mark="hideMark"
          :type="type"
          :previewStatus="previewStatus"
          :readOnly="readOnly"
          :subjects="groupChild"
          :exam-index="key + 1"
          @add-show-image="elimage"
        />
        <el-divider />
      </div>
    </template>
    <dsf-exam-item
      v-else
      :show-score="showScore"
      :hide-mark="hideMark"
      :type="type"
      :readOnly="readOnly"
      :previewStatus="previewStatus"
      :subjects="subjects"
      :exam-index="examIndex + 1"
      @add-show-image="elimage"
    />
    <el-image ref="elimage" v-if="srcList && srcList.length > 0" :preview-src-list="srcList" class="elimage" />
  </div>
</template>
<script>
// 试题控件组
export default {
  name: "DsfExamItemBox",
  props: {
    type: {
      // exam practice
      type: String,
      default: "exam",
    },
    previewStatus: {
      type: Boolean,
      default: false,
    },
    subjects: {
      type: Object,
      default() {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    examIndex: {
      type: [Number, String],
      default: 1,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
    hideMark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      srcList: [],
    };
  },
  created() {},
  computed: {
    regHtml() {
      let title =
        this.subjects.name &&
        this.subjects.name
          .replace(/label=\s*?(['"])[\s\S]*?\1/gi, "")
          .replace(/style\s*?=\s*?(['"])[\s\S]*?\1/gi, "")
          .replace(/(<\/?font.*?>)|(<\/?span.*?>)|(<\/?a.*?>)|(<\/?strong.*?>)|(<\/?em.*?>)|(<\/?b.*?>)/gi, "")
          .replace(/<h[1-6][\s\S]*?>(.*?)<\/h[1-6]>/gi, "<p>$1</p>");
      return this.examIndex + 1 + ".&nbsp;" + title;
    },
  },
  methods: {
    showImage(e) {
      if (e.target.nodeName.toLowerCase() === "img") {
        this.elimage([e.target.src]);
      }
    },
    elimage(image) {
      this.srcList = image;
      this.$nextTick(() => {
        this.$refs.elimage.showViewer = true;
        $(".el-image-viewer__mask").click(() => {
          this.$refs.elimage.closeViewer();
        });
      });
    },
  },
};
</script>
